import { ItemList } from '../../orm'
import { download } from '../../actions/lib'

class AdminSubscriptionReportList extends ItemList {
    getEntityKey() {
        return "admin/subscription_report/generate"
    }

    createListReport({filter}) {
        return this.saveNewObject({filter:filter, report_type: 'list'})
    }

}

export const adminSubscriptionReportList = new AdminSubscriptionReportList("admin_subscription_report__default")
